export const routePrefix = process.env.PUBLIC_URL || ''
